export const StandardBaskets = [
    { name: 'AfamCand', key: ['AfamCand'], cand: [] },
    { name: 'AntiBOBO', key: ['AntiBOBO'], cand: [] },
    { name: 'AntiMTG', key: ['AntiMTG'], cand: [] },
    { name: 'AntiVillain', key: ['AntiVillain'], cand: [] },
    { name: 'BoldPAC', key: ['BoldPAC'], cand: [] },
    { name: 'CandEvil', key: ['CandEvil'], cand: [] },
    { name: 'CBC', key: ['CBC'], cand: [] },
    { name: 'ColoradoUniversities', key: ['ColoradoUniversities'], cand: [] },
    { name: 'Committees', key: ['Committees'], cand: [] },
    { name: 'Crazy', key: ['Crazy'], cand: [] },
    { name: 'DemocraticLeadership', key: ['DemocraticLeadership'], cand: [] },
    { name: 'ELChallenger', key: ['ELChallenger'], cand: [] },
    { name: 'EmilysListCand', key: ['EmilysListCand'], cand: [] },
    { name: 'EmilysListCands2026', key: ['EmilysListCands2026'], cand: [] },
    { name: 'Establishment', key: ['Establishment'], cand: [] },
    { name: 'Fashion', key: ['Fashion'], cand: [] },
    { name: 'FedEmilysListCands2024', key: ['FedEmilysListCands2024'], cand: [] },
    { name: 'FemaleAfamCands', key: ['FemaleAfamCands'], cand: [] },
    { name: 'Frontline2020', key: ['Frontline2020'], cand: [] },
    { name: 'Frontline2022', key: ['Frontline2022'], cand: [] },
    { name: 'Frontline2024', key: ['Frontline2024'], cand: [] },
    { name: 'Frontline2026', key: ['Frontline2026'], cand: [] },
    { name: 'GayCands', key: ['GayCands'], cand: [] },
    { name: 'Governor', key: ['Governor'], cand: [] },
    { name: 'GovWatchDogs', key: ['GovWatchDogs'], cand: [] },
    { name: 'HIV', key: ['HIV'], cand: [] },
    { name: 'HouseIncumbents', key: ['HouseIncumbents'], cand: [] },
    { name: 'HousingGiver', key: ['HousingGiver'], cand: [] },
    { name: 'IndianImpact', key: ['IndianImpact'], cand: [] },
    { name: 'InternationalConservation', key: ['InternationalConservation'], cand: [] },
    { name: 'JusticeDems', key: ['JusticeDems'], cand: [] },
    { name: 'LatinaCands', key: ['LatinaCands'], cand: [] },
    { name: 'LatinoCands', key: ['LatinoCands'], cand: [] },
    { name: 'LeadersWeDeserve', key: ['LeadersWeDeserve'], cand: [] },
    { name: 'MuslimCands', key: ['MuslimCands'], cand: [] },
    { name: 'PacificIslanderCands', key: ['PacificIslanderCands'], cand: [] },
    { name: 'EastAsianCands', key: ['EastAsianCands'], cand: [] },
    { name: 'MiddleEasternCands', key: ['MiddleEasternCands'], cand: [] },
    { name: 'SouthAsianCands', key: ['SouthAsianCands'], cand: [] },
    { name: 'LesbianCands', key: ['LesbianCands'], cand: [] },
    { name: 'Mothership', key: ['Mothership'], cand: [] },
    { name: 'MaleAfamCands', key: ['MaleAfamCands'], cand: [] },
    { name: 'NativeCand', key: ['NativeCand'], cand: [] },
    { name: 'NaturalDisasters', key: ['NaturalDisasters'], cand: [] },
    { name: 'NorthCarolina', key: ['NorthCarolina'], cand: [] },
    { name: 'ProgressiveCand', key: ['ProgressiveCand'], cand: [] },
    { name: 'ProgressiveCaucus', key: ['ProgressiveCaucus'], cand: [] },
    { name: 'RedToBlue2020', key: ['RedToBlue2020'], cand: [] },
    { name: 'RedToBlue2022', key: ['RedToBlue2022'], cand: [] },
    { name: 'RedToBlue2024', key: ['RedToBlue2024'], cand: [] },
    { name: 'RedToBlue2026', key: ['RedToBlue2026'], cand: [] },
    { name: 'SenateIncumbents', key: ['SenateIncumbents'], cand: [] },
    { name: 'Squad', key: ['Squad'], cand: [] },
    { name: 'SquadExpanded', key: ['SquadExpanded'], cand: [] },
    { name: 'TexasCand', key: ['TexasCand'], cand: [] },
    { name: 'TopFlips', key: ['TopFlips'], cand: [] },
    { name: 'TopPAC', key: ['TopPAC'], cand: [] },
    { name: 'TopSenate2022', key: ['TopSenate2022'], cand: [] },
    { name: 'TopSenate2024', key: ['TopSenate2024'], cand: [] },
    { name: 'Trans/NonbinaryCands', key: ['Trans/NonbinaryCands'], cand: [] },
    { name: 'TXCands', key: ['TXCands'], cand: [] },
    { name: 'VoteVeteransHouseCands', key: ['VoteVeteransHouseCands'], cand: [] },
    { name: 'VoteVeteransSenateCands', key: ['VoteVeteransSenateCands'], cand: [] },
    { name: 'LGBTQ', key: ['LGBTQ'], cand: [] },
    { name: 'Education', key: ['Education'], cand: [] },
    { name: 'CivilRights', key: ['CivilRights'], cand: [] },
    { name: 'Journalists', key: ['Journalists'], cand: [] },
    { name: 'Evangelical', key: ['Evangelical'], cand: [] },
    { name: 'Environment', key: ['Environment'], cand: [] },
    { name: 'FoodAid', key: ['FoodAid'], cand: [] },
    { name: 'GunViolence', key: ['GunViolence'], cand: [] },
    { name: 'AnimalWelfare', key: ['AnimalWelfare'], cand: [] },
    { name: 'Hospitals', key: ['Hospitals'], cand: [] },
    { name: 'GenZVote', key: ['GenZVote'], cand: [] },
    { name: 'Veterans', key: ['Veterans'], cand: [] },
    { name: 'Foundations', key: ['Foundations'], cand: [] },
    { name: 'ADA', key: ['ADA'], cand: [] },
    { name: 'Immigration', key: ['Immigration'], cand: [] },
    { name: 'Medicaid', key: ['Medicaid'], cand: [] },
    { name: 'Abortion', key: ['Abortion'], cand: [] },
    { name: 'NWLC', key: ['NWLC'], cand: [] },
    { name: 'Cancer', key: ['Cancer'], cand: [] },
    { name: 'Science', key: ['Science'], cand: [] },
    { name: 'Poverty', key: ['Poverty'], cand: [] },
    { name: 'VoteVeterans2026', key: ['VoteVeterans2026'], cand: [] },
    { name: 'NewDems', key: ['NewDems'], cand: [] },
    { name: 'TopSenate2026', key: ['TopSenate2026'], cand: [] },
    { name: 'ProgressivePrimaryChallengers', key: ['ProgressivePrimaryChallengers'], cand: [] },
    { name: 'Refugee', key: ['Refugee'], cand: [] },
    { name: 'ProgressiveMayors', key: ['ProgressiveMayors'], cand: [] },
    { name: 'WhiteMen', key: ['WhiteMen'], cand: [] },
    { name: 'Arboretum', key: ['Arboretum'], cand: [] },
    { name: 'Arts', key: ['Arts'], cand: [] },
    { name: 'Doctors', key: ['Doctors'], cand: [] },
    { name: 'Mayors', key: ['Mayors'], cand: [] },
    { name: 'AttorneyGeneral', key: ['AttorneyGeneral'], cand: [] },
    { name: 'SecretaryOfState', key: ['SecretaryOfState'], cand: [] },
    { name: 'SpecialElections119th', key: ['SpecialElections119th'], cand: [] },
    { name: 'VeteranSupportOrgs', key: ['VeteranSupportOrgs'], cand: [] },
    { name: 'DemDeserters', key: ['DemDeserters'], cand: [] },
    { name: 'JewishOrgs', key: ['JewishOrgs'], cand: [] },
    { name: 'DomesticViolence', key: ['DomesticViolence'], cand: [] },
];

const demographicList = [
    'Custom',
    'ACLU',
    'Accountant',
    'Activist',
    'Advertising',
    'Aerospace',
    'AfamAff',
    'Afghani',
    'Agriculture',
    'AnyChanceIndian',
    'Artist',
    'Attorney',
    'Baseball',
    'Biking',
    'CampaignOperative',
    'CharterSchool',
    'ChineseAmerican',
    'Coach',
    'CommerceAff',
    'Consumer',
    'Craftsmen',
    'Dentist',
    'Divine9',
    'Doctor',
    'Economist',
    'Ecuadorian',
    'EmergencyResponder',
    'EntertainmentInd',
    'Eritrean',
    'Ethiopian',
    'EthiopianEritrean',
    'FPAff',
    'Farmer',
    'FemAfam',
    'FemaleFirstName',
    'FemaleSupporters',
    'Finance',
    'Fitness',
    'GCAff',
    'GovShutdown',
    'HBCU',
    'Haitian',
    'HealthClinic',
    'Hockey',
    'Hospitality',
    'HumanResources',
    'Hungarian',
    'Insurance',
    'InternetComputers',
    'Iranian',
    'Irish',
    'Italian',
    'JFN',
    'JLN',
    'JapaneseAmerican',
    'JewishAff',
    'LGBTQAff',
    'Latino',
    'Lobbyist',
    'MaleAfam',
    'Media',
    'MedicalDevice',
    'Meteorology',
    'Military',
    'MilitaryAcademy',
    'Minister',
    'ModelFashion',
    'Mother',
    'Music',
    'Muslim',
    'MuslimMen',
    'MuslimWomen',
    'NativeAmericans',
    'NonProfit',
    'Nutrition',
    'OBGYN',
    'Oil',
    'Otolaryngology',
    'Owner',
    'PPSupporter',
    'Palestinian',
    'ParksAndRec',
    'Pastor',
    'PatentLawyer',
    'Politico',
    'PreK',
    'Professor',
    'PublicHealth',
    'RealEstate',
    'Religious',
    'Renewables',
    'Retail',
    'Retired',
    'SciFi',
    'Scientist',
    'Slovak',
    'SocialWork',
    'Solar',
    'Sportsmen',
    'Teacher',
    'TechInd',
    'Top20Schools',
    'Transportation',
    'Ukrainian',
    'UNC',
    'UrbanPlanning',
    'VCInvestedInAfamFounder',
    'Vanderbilt',
    'Venezuelan',
    'Vietnamese',
    'Veterinarian',
    'WestAfrican',
    'WestAfricanFemale',
    'WestAfricanMale',
    'WomensEthnicStudies',
    'WorkersCompAttorney',
    'Yoga',
];

export const DemographicBaskets = demographicList.map((name) => {
    return { name, key: [name], demo: [] };
});
